// extracted by mini-css-extract-plugin
export default {"drawerContent":"Follow_drawerContent__t38Mz","bottomBox":"Follow_bottomBox__9edtF"};